import { updateBulletData } from './utils';
import { spliceArray } from '../../handlers/utils';

/**
 *
 * @param jobSeekerData
 * @param option
 * @param stateProps
 */
export const select = (jobSeekerData, option, stateProps) => {
  const index = stateProps.sectionData.sectionIndex;
  let add = true;
  if(jobSeekerData[index]['bulletsb'] === undefined) {
    jobSeekerData[index]['bulletsb'] = [];
  }
  for (var i = 0; i < jobSeekerData[index]['bulletsb'].length; i++) {
    const existingOption = jobSeekerData[index]['bulletsb'][i];
    if (existingOption.key === option.key) {
      add = false;
      break;
    }
  }
  if (add) {
    const newUnselected = JSON.parse(JSON.stringify(stateProps.bulletData.unselectedBullets));
    newUnselected[option.type] = spliceArray(newUnselected[option.type], [option]);
    //  newUnselected['all'] = spliceArray(newUnselected['all'], [option]);
    jobSeekerData[index]['bulletsb'].push(option);
    updateBulletData({
        unselectedBullets: newUnselected,
        selectedBullets: jobSeekerData[index]['bulletsb'],
      },
      stateProps);
  }
};

/**
 *
 * @param jobSeekerData
 * @param option
 * @param stateProps
 */
export const unSelect = (jobSeekerData, option, stateProps) => {
  const index = stateProps.sectionData.sectionIndex;
  const usb = JSON.parse(JSON.stringify(stateProps.bulletData.unselectedBullets));
  if (usb[option.type]) {
    usb[option.type].unshift(option);
  }
  const sb = spliceArray(stateProps.bulletData.selectedBullets, [option]);
  updateBulletData({
    unselectedBullets: usb,
    selectedBullets: sb,
  }, stateProps);
  jobSeekerData[index]['bulletsb'] = spliceArray(jobSeekerData[index]['bulletsb'], [option]);

};


/**
 *
 * @param stateProps
 * @param newBullet
 */
export const switchBullets = (stateProps, newBullet) => {
  updateBulletData({ bulletGroup: newBullet }, stateProps);
};